import * as types from './actionTypes';
import * as API_END_POINTS from '../constants/api.js';
import axios from 'axios';
import {getBusinessTax} from './commonActions';

export function changePasswordAction(changeData) {
  return dispatch => {
    //axios.defaults.headers.common['x-access-token'] = localStorage.getItem('businessAccessToken');
    axios
      .put(API_END_POINTS.CHANGE_PASSWORD, JSON.stringify(changeData), {
        headers: {
          Accept: 'application/json,',
          'Content-Type': 'application/json'
        }
        // withCredentials:true
      })
      .then(response => {
        if (response.status === 200) {
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: 'Password Change succesfully',
            toastType: 'success'
          });
        }
      })
      .catch(err => {
        dispatch({
          type: types.SHOW_TOAST_MESSAGE,
          toastMessage: err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Unknown error occurred please try again',
          toastType: 'error'
        });
      });
  };
}

export function getGarageInfo() {
  let garage_id = JSON.parse(localStorage.getItem('garage_id'));
  return dispatch => {
    // const postMethod = (methodType == 'get') ? axios.get : axios.post;
    axios
      .get(API_END_POINTS.GET_GARAGE_PROFILE, {
        headers: {
          'garage-id': garage_id,
          Accept: 'application/json,',
          'Content-Type': 'application/json'
        }
        //withCredentials:true
      })
      .then(response => {
        if (response.status === 200) {
          dispatch({
            type: types.GET_NOTIFICATION_INFO,
            notificationRequests: response.data
          });
        } else {
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: response && response.data && response.data.message
              ? response.data.message
              : 'Unknown error occurred please try again',
            toastType: 'error'
          });
        }
      })
      .catch(err => {
        dispatch({
          type: types.SHOW_TOAST_MESSAGE,
          toastMessage: err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Unknown error occurred please try again',
          toastType: 'error'
        });
      });
  };
}
export function notificatioPreferenceUpdate(updateData) {
  return dispatch => {
    //axios.defaults.headers.common['x-access-token'] = localStorage.getItem('businessAccessToken');
    axios
      .post(API_END_POINTS.NOTIFICATION_PREFERENCE_UPDATE, updateData, {
        headers: {
          Accept: 'application/json,',
          'Content-Type': 'application/json'
        }
        // withCredentials:true
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(getGarageInfo());
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: 'Notification Preference Change succesfully',
            toastType: 'success'
          });
        }
      })
      .catch(err => {
        dispatch({
          type: types.SHOW_TOAST_MESSAGE,
          toastMessage: err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Unknown error occurred please try again',
          toastType: 'error'
        });
      });
  };
}

export function contactDetailsUpdate(changeData, businessData) {
  return dispatch => {
    let businessDataInfo = businessData;
    //axios.defaults.headers.common['x-access-token'] = localStorage.getItem('businessAccessToken');
    axios
      .put(API_END_POINTS.CONTACTDETAILSUPDATE, JSON.stringify(changeData), {
        headers: {
          Accept: 'application/json,',
          'Content-Type': 'application/json'
        }
        //withCredentials:true
      })
      .then(response => {
        //alert(23);

        if (response.status === 200) {
          let localDetails = JSON.parse(localStorage.getItem('businessAuthData'));
          if (changeData.otp) {
            localDetails.name = response.data.name;
            if (response.data.profile_photo) {
              localDetails.profilePhoto = response.data.profile_photo;
            }
            localDetails.phone = response.data.phone;
            localStorage.setItem('businessAuthData', JSON.stringify(localDetails));
            window.history.back();
          } else {
            localDetails.name = response.data.name;
            if (response.data.profile_photo) {
              localDetails.profilePhoto = response.data.profile_photo;
            }
            localStorage.setItem('businessAuthData', JSON.stringify(localDetails));
          }
          dispatch(updateBusinessProfile(businessDataInfo));
          /*dispatch({
          type: types.PROFILE_IMAGE_UPDATED,
          profileImageUploaded: true
        });*/
        }
      })
      .catch(err => {
        dispatch({
          type: types.SHOW_TOAST_MESSAGE,
          toastMessage: err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Unknown error occurred please try again',
          toastType: 'error'
        });
      });
  };
}

export function sendOtp(phoneNumber) {
  return dispatch => {
    //axios.defaults.headers.common['x-access-token'] = localStorage.getItem('businessAccessToken');
    axios
      .post(API_END_POINTS.SENDOTP, JSON.stringify({ phone: phoneNumber }), {
        headers: {
          Accept: 'application/json,',
          'Content-Type': 'application/json'
        }
        // withCredentials:true
      })
      .then(response => {
        if (response.status === 200) {
          alert('otp is send to the mobile');
        }
      })
      .catch(err => {
        dispatch({
          type: types.SHOW_TOAST_MESSAGE,
          toastMessage: err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Unknown error occurred please try again',
          toastType: 'error'
        });
      });
  };
}

export function sign_request(file, savetype, done) {
  return dispatch => {
    dispatch({
      type: types.PROFILE_IMAGE_UPDATED,
      profileImageUploaded: true
    });
    axios
      .get(
        API_END_POINTS.IMAGE_UPLOAD_REQUEST +
          file.name +
          '&file_type=' +
          file.type +
          '&width=150&height=150&for=' +
          savetype,
        {
          headers: {
            Accept: 'application/json,',
            'Content-Type': 'application/json'
          }
        }
      )
      .then(response => {
        if (response.status === 200) {
          let responseData = response;
          console.log("img uploaded = ", responseData);
          done(responseData);
        }
      })
      .catch(err => {
        dispatch({
          type: types.SHOW_TOAST_MESSAGE,
          toastMessage: err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Unknown error occurred please try again',
          toastType: 'error'
        });
        dispatch({
          type: types.PROFILE_IMAGE_UPDATED,
          profileImageUploaded: false
        });
      });
  };
}

export function uploadImageDP(file, signed_request, url, done) {
  return dispatch => {
    axios
      .put(signed_request, file, {
        headers: {
          'Content-Type': file.type,
          'x-amz-acl': 'public-read'
        }
      })
      .then((response, test) => {
        console.log("imgresp = ", response, test);
        if (response.status === 200) {
          let responseData = response;
          done(responseData);
        }
        dispatch({
          type: types.PROFILE_IMAGE_UPDATED,
          profileImageUploaded: false
        });
      })
      .catch(err => {
        console.log("err = ", err);
        dispatch({
          type: types.SHOW_TOAST_MESSAGE,
          toastMessage: err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Unknown error occurred please try again',
          toastType: 'error'
        });
        dispatch({
          type: types.PROFILE_IMAGE_UPDATED,
          profileImageUploaded: false
        });
      });
  };
}

export function getVendorInfo() {
  let garage_id = JSON.parse(localStorage.getItem('garage_id'));
  return dispatch => {
    axios
      .get(API_END_POINTS.GET_USER_DETAIL_INFO, {
        headers: {
          'garage-id': garage_id,
          Accept: 'application/json,',
          'Content-Type': 'application/json'
        }
        //withCredentials:true
      })
      .then(response => {
        if (response.status == 200) {
          dispatch({
            type: types.GET_VENDOR_INFO,
            vendorInfo: response.data
          });
        }
      })
      .catch(err => {
        dispatch({
          type: types.SHOW_TOAST_MESSAGE,
          toastMessage: err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Unknown error occurred please try again',
          toastType: 'error'
        });
      });
  };
}

export function updateBusinessProfile(profileData) {
  const formData = new FormData();
  Object.keys(profileData).map(value => {
    if (profileData[value]) {
      formData.append(value, profileData[value]);
    }
  });
  return dispatch => {
    axios
      .post(
        API_END_POINTS.BUSINESS_PROFILE_REGISTRATION + '?imageflow=1',
        profileData,
        {
          // withCredentials: true
        }
      )
      .then(response => {
        if (response.status === 200) {
          dispatch(getVendorInfo());
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: 'Contact Details Updated succesfully',
            toastType: 'success'
          });
        }
      })
      .catch(err => {
        dispatch({
          type: types.SHOW_TOAST_MESSAGE,
          toastMessage: err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Unknown error occurred please try again',
          toastType: 'error'
        });
      });
  };
}

export function updateBusinessTax(taxData) {

  return dispatch => {
    axios
      .post(
        API_END_POINTS.BUSINESS_TAX,
        taxData,
        {
          // withCredentials: true
        }
      )
      .then(response => {
        if (response.status === 200) {
          dispatch(getBusinessTax());
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: 'Tax Details Updated succesfully',
            toastType: 'success'
          });
        }
      })
      .catch(err => {
        dispatch({
          type: types.SHOW_TOAST_MESSAGE,
          toastMessage: err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Unknown error occurred please try again',
          toastType: 'error'
        });
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/useraccountActions.js